import React, { useEffect } from "react";
import { Notification } from "../common/Notification";
import { CloseDialogContext } from "./../common/DialogComponent";
import { useTranslation } from "react-i18next";

const FraudAlertReminderDialog = (props: any) => {
    const { t: tLang } = useTranslation();
    const closeDialog: any = React.useContext(CloseDialogContext);
    const handleRedirect = (e: any): void => {
        e.preventDefault();
        props.handleStateChange(props.reminderDate, true);
        window.open("https://www.transunion.com/fraud-alerts", "_blank");
    };

    const setFraudAlertReminder = () => {
        const url = "api/fraudAlertReminder/setFraudAlertReminder";
        const data: any = {};
        props
            .callAPI(url, data)
            .then((res: any): any => res.json())
            .then((res: any): any => {
                const response = JSON.parse(res);
                if (response["status-code"] === 200) {
                    props.handleStateChange(response["data"]["reminder-date"], true);
                    closeDialog("dialog-set-fraud-alert-reminder");
                    Notification({
                        id: "setFraudAlertReminderSucess",
                        type: "success",
                        title: tLang("credit.creditScore.fraudAlertReminderWidget.toasterMessage.success.title"),
                        message: tLang("credit.creditScore.fraudAlertReminderWidget.toasterMessage.success.message"),
                    });
                }
            })
            .catch((error: Error): any => {
                console.log(error);
                closeDialog("dialog-set-fraud-alert-reminder");
                Notification({
                    id: "setFraudAlertReminderError",
                    type: "error",
                    title: tLang("credit.creditScore.fraudAlertReminderWidget.toasterMessage.error.title"),
                    message: tLang("credit.creditScore.fraudAlertReminderWidget.toasterMessage.error.message"),
                    duration: 0,
                });
            });
    };

    useEffect(() => {
        const closeBtn: any = document.getElementById("closeButton");
        closeBtn.addEventListener("click", () => closeDialog("dialog-set-fraud-alert-reminder"), false);
        window.addEventListener("keyup", (evt: any) => {
            evt = evt || window.event;
            var isEscape = false;
            if ("key" in evt) {
                isEscape = evt.key === "Escape" || evt.key === "Esc";
            } else {
                isEscape = evt.keyCode === 27;
            }
            if (isEscape) {
                closeDialog("dialog-set-fraud-alert-reminder");
            }
        });
        return () => {
            window.removeEventListener("keyup", () => {});
        };
    });

    return (
        <React.Fragment>
            {/* <!-- This is the Content we can add into the Modal Body --> */}
            <div className="dialog-header">
                <div className="dialog-icon">
                    <em className="las la-calendar-day"></em>
                </div>
                <h1>{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.title")}</h1>
            </div>
            <div className="dialog-body">
                <p>{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.messagePara1")}</p>
                <p>{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.messagePara2")}</p>
                <p>
                    <button type="button" className="btn-default btn-area" onClick={(e: any) => handleRedirect(e)}>
                        <span className="btn-icon">
                            <em className="las la-plus"></em>
                        </span>
                        <span className="btn-title">
                            {tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.setReminderLinkText")}{" "}
                            <em title="This link opens a new window." className="las la-external-link-alt"></em>
                        </span>
                    </button>
                </p>
                <p>{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.messagePara3")}</p>

                {props.showSetReminderBtn && (
                    <div id="more-info">
                        {props.reminderDate && (
                            <p>
                                <strong>
                                    {tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.reminderSetMessage")}{" "}
                                    {props.formatDate(props.reminderDate)}.
                                </strong>
                            </p>
                        )}
                        {!props.reminderDate && (
                            <p>
                                <strong>{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.reminderSetMessage")}</strong>
                            </p>
                        )}
                        <p>
                            <button type="button" className="btn-default btn-primary-outline" onClick={() => setFraudAlertReminder()}>
                                <span className="btn-text">
                                    {tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.reminderSetConfirmationButtonText")}
                                </span>
                            </button>
                        </p>
                        <p>
                            {tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.additionalQuestionText")}{" "}
                            <a href="https://www.transunion.com/fraud-alerts#faq" className="default_link" target="_blank">
                                {" "}
                                {tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.additionalQuestionInfoLinkText")}{" "}
                                <em className="las la-external-link-alt"></em> <span className="sr-only">Link opens a new window.</span>
                            </a>
                            .
                        </p>
                    </div>
                )}
            </div>
            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs col-no-gutter flex-grow-null"></div>
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" id="closeButton" data-a11y-dialog-hide="true">
                            <span className="btn-text">{tLang("credit.creditScore.fraudAlertReminderWidget.setReminderPopup.closeButtonText")}</span>
                        </button>
                    </div>
                </div>
            </div>
            {/* <!-- End of Dialog Body --> */}
        </React.Fragment>
    );
};

export default FraudAlertReminderDialog;
